import * as React from 'react'
import g from 'glamorous'
import { RouteComponentProps, Redirect } from 'react-router'
import { Link } from 'react-router-dom'
import { Alert } from 'react-bootstrap'
import queryString from 'query-string'

import SetPasswordForm from './setPassword/SetPasswordForm'
import Headline from '../components/Headline'
import Loading from '../components/Loading'
import ChangePasswordByTokenMutation from '../components/mutations/ChangePasswordByTokenMutation'

export type SetPasswordProps = RouteComponentProps<{}>

const StyledContainer = g.div(({ theme }) => {
  return {
    maxWidth: '600px',
    width: '100%',
    margin: '0 auto'
  }
})

const SetPassword: (title: string) => React.SFC<SetPasswordProps> = (title) => ({ location }) => {
  const { token } = queryString.parse(location.search)

  if (token == null || token.trim().length === 0) {
    return <Redirect to="/" />
  }

  return (
    <StyledContainer>
      <Headline>{title}</Headline>
      <ChangePasswordByTokenMutation>
        {(requestPassword, { data, called, error, loading }) => {
          if (loading) {
            return <Loading />
          }

          if (called && error == null) {
            return (
              <Alert bsStyle="success">
                Vaše heslo bylo nastaveno, můžete se <Link to="/login">přihlásit</Link>
              </Alert>
            )
          }

          return (
            <div>
              {error != null && (
                <Alert bsStyle="danger">
                  Při vašem požadavku nastala chyba.<br />
                  Váš token je pravděpodobně neplatný
                </Alert>
              )}
              <SetPasswordForm
                onSubmit={async ({ password }) => {
                  const result = await requestPassword({
                    variables: { password, token }
                  })

                  if (result == null || result.data == null) {
                    return
                  }
                }}
              />
            </div>
          )
        }}
      </ChangePasswordByTokenMutation>
    </StyledContainer>
  )
}

export default SetPassword



// WEBPACK FOOTER //
// ./src/screens/SetPassword.tsx